import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	min-width: 0;
	gap: 4px;
`;
